const $$splitComponentImporter = () => import('/app/src/routes/{-$locale}/offers/$id/related.tsx?tsr-split=component');
import { lazyRouteComponent } from '@tanstack/react-router';
import { getQueryClient } from "@/lib/client";
import { generateOfferMeta } from "@/lib/generate-offer-meta";
import { getFetchedQuery } from "@/lib/get-fetched-query";
import { httpClient } from "@/lib/http-client";
import { offerOnlyQueryOptions } from "@/queries/offer-gql";
import { dehydrate } from "@tanstack/react-query";
import { createFileRoute } from "@tanstack/react-router";
import i18n from "@/lib/i18n";
type LoaderData = {
  dehydratedState: DehydratedState;
  id: string;
  offer: SingleOffer | null;
  country: string;
  locale: string | undefined;
};
export const Route = createFileRoute("/{-$locale}/offers/$id/related")({
  component: lazyRouteComponent($$splitComponentImporter, 'component'),
  loader: async ({
    params,
    context
  }) => {
    const {
      queryClient,
      country,
      locale
    } = context;
    const {
      id
    } = params;
    const offer = await queryClient.ensureQueryData(offerOnlyQueryOptions(id, locale));
    await queryClient.prefetchQuery({
      queryKey: ["related-offers", {
        id,
        country
      }],
      queryFn: () => httpClient.get<SingleOffer[]>(`/offers/${id}/related`, {
        params: {
          country
        }
      }).catch(() => [])
    });
    return {
      id,
      dehydratedState: dehydrate(queryClient),
      offer,
      country,
      locale
    };
  },
  head: ctx => {
    const {
      params
    } = ctx;
    const queryClient = getQueryClient();
    if (!ctx.loaderData) {
      return {
        meta: [{
          title: i18n.t("offerDetail.common.offerNotFound"),
          description: i18n.t("offerDetail.common.offerNotFound")
        }]
      };
    }
    const offer = getFetchedQuery<SingleOffer>(queryClient, ctx.loaderData?.dehydratedState, [...offerOnlyQueryOptions(params.id, ctx.loaderData?.locale).queryKey]);
    if (!offer) {
      return {
        meta: [{
          title: i18n.t("offerDetail.common.offerNotFound"),
          description: i18n.t("offerDetail.common.offerNotFound")
        }]
      };
    }
    return {
      meta: generateOfferMeta(offer, i18n.t("offerDetail.related.title"))
    };
  }
});